import React, { useState, useEffect } from 'react';

import { Fieldset } from 'primereact/fieldset';
import { InputNumber } from 'primereact/inputnumber';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Card } from 'primereact/card';


import { getStates } from './HTTPService';
import { properties } from '../properties';
import apiFetch from '../auth/apiFetch';
import { InputText } from 'primereact/inputtext';


function Admin() {



  const { t } = useTranslation();
  const [valueYearCard, setValueYearCard] = useState();



  const [url, setUrl] = useState(properties.baseURL + properties.jkaCardListPath);
  const [gymUrl, setGymUrl] = useState(properties.baseURL + properties.gymsCSVPath);

  const [addAnnuitiesByStatePath, setAddAnnuitiesByStatePath] = useState(properties.baseURL + properties.addAnnuitiesByStatePath);

  const [judgesClassListUrl, setjudgesClassListUrl] = useState(properties.baseURL + properties.judgesClassListCSVPath);
  const [instructorsClassListUrl, setInstructorsClassListUrl] = useState(properties.baseURL + properties.instructorsClassListCSVPath);
  const [examinersClassListUrl, setExaminersClassListUrl] = useState(properties.baseURL + properties.examinersClassListCSVPath);
  const [gymsUpdateGeoCodePath, setGymsUpdateGeoCodePath] = useState(properties.baseURL + properties.gymsUpdateGeoCodePath);
  const [shihankaiListPath, setShihankaiListPath] = useState(properties.baseURL + properties.shihankaiListPath);
  const [blackBeltsListCSVPath, setblackBeltsListCSVPath] = useState(properties.baseURL + properties.blackBeltsListCSVPath);

  const [judgesUpdateGeoCodePath, setJudgesUpdateGeoCodePath] = useState(properties.baseURL + properties.judgesUpdateGeoCodePath);

  const [addTeacherNotAffiliatedPath, setAddTeacherNotAffiliatedPath] =  useState(properties.baseURL + properties.teachersPath);
  const [year, setYear] = useState('');
  const [date, setDate] = useState('');
  const [stateId, setStateId] = useState('');
  const [states, setStates] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  const [valueTeacherName, setValueTeacherName] = useState('');


  const [mensagem, setMensagem] = useState('');
  const [fileName, setFileName] = useState('carteirinhas.xlsx');


  useEffect(() => {
    getStates().then(data => setStates(data));
  }, []);

  const onStateChange = (e) => {
    // setSelectedState(e.value.id);
    setStateId(e.value.id);
    setSelectedState(e.value);
  }


  async function handleDownload() {

    const response = await apiFetch(url + '/' + valueYearCard);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = 'carteirinhas/' + valueYearCard + '.xlsx';
    anchor.click();
  };

  async function handleBacklBeltExcelDownload() {

    const response = await apiFetch(properties.baseURL + properties.blackBeltsDanXlsPath);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = 'faixas_pretas_dan.xlsx';
    anchor.click();
  };



  async function handleBacklBeltDownload() {
    const response = await apiFetch(blackBeltsListCSVPath);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);


    anchor.download = 'blackbelts.csv';
    anchor.click();
  };


  async function handleGymDownload() {

    const response = await apiFetch(gymUrl);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);


    anchor.download = 'gyms.csv';
    anchor.click();
  };

  async function handleJudgesClassListDownload() {

    const response = await apiFetch(judgesClassListUrl);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);

    anchor.download = 'judges.csv';
    anchor.click();
  };

  async function handleIntructorsClassListDownload() {

    const response = await apiFetch(instructorsClassListUrl);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);

    anchor.download = 'instructors.csv';
    anchor.click();
  };

  async function handleExaminersClassListDownload() {

    const response = await apiFetch(examinersClassListUrl);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);

    anchor.download = 'examiners.csv';
    anchor.click();
  };


  async function handleShihankaiListDownload() {

    const response = await apiFetch(shihankaiListPath);
    const blob = await response.blob();
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);

    anchor.download = 'shihankai.csv';
    anchor.click();
  };

  async function handleUpdateGymsGeoCode() {

    const response = await apiFetch(gymsUpdateGeoCodePath);
    alert(JSON.stringify(response) + " academias atualizadas");

  };


  async function handleUpdateJudgesGeoCode() {
    const response = await apiFetch(judgesUpdateGeoCodePath, { method: 'POST' });
    alert(JSON.stringify(response) + " juízes atualizados");

  };

  async function handleUpdateAnnuities() {

    const response = await apiFetch(addAnnuitiesByStatePath + '/' + stateId + '/date/' + date + '/year/' + year);
    alert(JSON.stringify(response) + " anuidades inseridas para o ano de " + year);

  };

  async function handleInsertTeacher () {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
  };

    const response = await apiFetch(addTeacherNotAffiliatedPath + '/' + valueTeacherName, requestOptions);
    alert(JSON.stringify(response) + " professor inserido");

  };

  return (

    <>
      <h1>Pagina administrativa da JKA</h1>

      <Fieldset>

      <Card title="Simple Card">
        <Panel header="Anuidades">
          <div className="formgrid grid contacts">
            <div className="field input text col-14">
              <label htmlFor="cardlist">{t('msg.jkaAnnuityforAllDojos')}</label>
              <InputNumber value={year} onValueChange={(e) => setYear(e.value)} />
              <InputMask mask="99-99-9999" placeholder="31-02-2023" value={date} onChange={(e) => setDate(e.target.value)} />
              <Dropdown value={selectedState} options={states} onChange={onStateChange}
                optionLabel="name" />
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleUpdateAnnuities}>Atualizar</Button>
            </div>
          </div>

        </Panel>
       </Card> 

        <p></p>

        <Panel header="Carteirinhas">

          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="cardlist">{t('msg.jkaCardList')}</label>
              <InputNumber value={valueYearCard} onValueChange={(e) => setValueYearCard(e.value)} />
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleDownload}>Download</Button>
            </div>
          </div>
        </Panel>
        <p></p>

        <Panel header="Inserir professor não filiado">

          <div className="formgrid grid contacts">
            <div className="field input text ">
              <label htmlFor="teachernotaffiliate">{t('msg.jkaTeacherNotAffiliate')}</label>
              <InputText value={valueTeacherName} onChange={(e) => setValueTeacherName(e.target.value)} />
              &nbsp; &nbsp; &nbsp;

              <Button onClick={handleInsertTeacher}>Atualizar</Button>
         
            </div>
          </div>
        </Panel>
        <p></p>

        <Panel header="Arquivos CSV">
          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="gymlist">{t('msg.jkaGymList')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleGymDownload}>Download</Button>
            </div>
          </div>


          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaBlackBeltDanList">{t('msg.jkaBlackBeltDanList')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleBacklBeltDownload}>Download</Button>
            </div>
          </div>


          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaJudgesClassList">{t('msg.jkaJudgesClassList')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleJudgesClassListDownload}>Download</Button>
            </div>
          </div>
          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaIntructorsClassList">{t('msg.jkaInstructorsClassList')}</label>
              &nbsp; &nbsp; &nbsp;  <Button onClick={handleIntructorsClassListDownload}>Download</Button>
            </div>
          </div>
          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaExaminersClassList">{t('msg.jkaExaminersClassList')}</label>
              &nbsp; &nbsp; &nbsp; <Button onClick={handleExaminersClassListDownload}>Download</Button>
            </div>
          </div>

          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaShihankaiList">{t('msg.jkaShihankaiList')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleShihankaiListDownload}>Download</Button>
            </div>
          </div>

        </Panel>

        <p></p>

        <Panel header="Excel">
          <div className="formgrid grid contacts">
            <div className="field input text col-6">
              <label htmlFor="blackBeltDanListExcel">{t('msg.jkaBlackBeltDanListExcel')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleBacklBeltExcelDownload}>Download</Button>
            </div>
          </div>
        </Panel>

        <p></p>

        <Panel header="GeoCodes">

          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaUpdateGymsGeoCode">{t('msg.jkaUpdateGymsGeoCode')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleUpdateGymsGeoCode}>Atualizar</Button>
            </div>
          </div>
          <div className="formgrid grid contacts">
            <div className="field input text col-4">
              <label htmlFor="jkaUpdateJudgesGeoCode">{t('msg.jkaUpdateJudgesGeoCode')}</label>
              &nbsp; &nbsp; &nbsp;
              <Button onClick={handleUpdateJudgesGeoCode}>Atualizar</Button>
            </div>
          </div>
        </Panel>

      </Fieldset>


    </>


  )
}

export default Admin;